import { startWith } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import 'brace';
import 'brace/mode/sql';
import 'brace/ext/language_tools';
import 'brace/snippets/sql';
import 'brace/ext/searchbox'
import * as ace from 'brace';
import { SyntheticReportColumn, ReportDashboardColumnMeta } from '@liquitics/transaction';
import { createSnippetTextGenerator, SyntheticColumnSnippetContext } from './synthetic-column-ace-snippet-library';
import sqlFormatter from 'sql-formatter';


@Component({
    selector: 'app-synthetic-column-builder',
    templateUrl: './synthetic-column-builder.component.html',
    styleUrls: ['./synthetic-column-builder.component.css']
})
export class SyntheticColumnBuilderComponent implements OnInit, AfterViewInit {
    userSQL: string;
    @ViewChild('editor', { static: false }) editor;
    text: string = '';
    hints: string[] = [];
    literalsUsed: string[] = [];
    numbersUsed: string[] = [];
    validations: string[];
    columnMeta: ReportDashboardColumnMeta[];
    customerColumnAliases: { [key: string]: string };
    // availableAttributeColumns: string[];
    // availableValueColumns: string[];
    syntheticReportColumns: SyntheticReportColumn[];
    distinctValues: { [columnName: string]: string[] };
    completer: any;
    snippetTextGenerator;
    commands = [
        { name: 'Open Auto-complete', keyBinding: 'Ctrl-space', description: 'Drops down the contextual auto completer' },
        { name: 'Insert from another', keyBinding: '$custom', description: 'Lists all defined Synthetic Column definition for injection' },
        { name: 'Show columns with literal', keyBinding: '$literal', description: 'Lists all available literal helpers. Ctrl-space after selection to show values' },
        { name: 'Show literal values', keyBinding: '$<column name>', description: 'Lists all literal values for the column' },
        { name: 'Auto Format', keyBinding: 'Ctrl-i', description: 'Formats the statement into standard SQL format' },
        { name: 'Search', keyBinding: 'Ctrl-f', description: 'Opens a search box' },
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.columnMeta = data.columnMeta
            .filter((meta) => {
                return meta.source === 'TRADE';
            });
        this.customerColumnAliases = this.customerColumnAliases = this.columnMeta
            .filter((meta) => {
                return meta.alias;
            })
            .reduce((agg, meta) => {
                agg[meta.columnName.toLowerCase()] = meta.alias;
                return agg;
            }, {});
        this.syntheticReportColumns = data.syntheticReportColumns || [];
        this.distinctValues = data.distinctValues || {};
        const context = {
            customerColumnAliases: this.customerColumnAliases,
            syntheticReportColumns: this.syntheticReportColumns,
            distinctValues: this.distinctValues,
        } as SyntheticColumnSnippetContext;
        this.snippetTextGenerator = createSnippetTextGenerator(context);
    }

    ngOnInit() {
    }

    findSnippetTextForIdentifier(identifier: string): string {
        const snippetTextArray: string[] = [];
        if (identifier === '') {

        }
        return snippetTextArray.join('');
    }

    addSnippets(editor, prefix: string) {
        const snippetManager = ace.acequire('ace/snippets').snippetManager;

        let snippetGen = this.snippetTextGenerator[prefix];
        let snippetText: string;
        const context = {
            customerColumnAliases: this.customerColumnAliases,
            syntheticReportColumns: this.syntheticReportColumns,
        } as SyntheticColumnSnippetContext;
        if (!snippetGen) {
            snippetGen = this.snippetTextGenerator['BASE'];
        }
        snippetText = snippetGen(context);
        const m = snippetManager.files[editor.session.$mode.$id];
        if (m.snippets) {
            snippetManager.unregister(m.snippets);
        }
        m.scope = 'sql';
        m.snippetText = snippetText;
        m.snippets = snippetManager.parseSnippetFile(snippetText, m.scope);

        snippetManager.register(m.snippets, m.scope);
    }

    ngAfterViewInit() {
        this.editor.getEditor().setValue(this.data.document);
        let completions = [];
        this.columnMeta
            .forEach((meta) => {
                let cap = meta.columnName.toLowerCase();
                const alias = meta.alias;
                if (alias) {
                    cap += `(${alias})`;
                }
                completions.push({
                    caption: cap,
                    value: meta.columnName.toLowerCase(),
                    meta: meta.usageType.toLowerCase()
                });
            });
        completions = completions.sort((c1, c2) => {
            return c1.value < c2.value ? -1 : 1;
        });
        completions = completions
            .map((c, index) => {
                c.score = 1000;
                return c;
            });
        this.completer = {
            getCompletions: (editor, session, pos, prefix, callback) => {
                const popup = editor.completer.getPopup();
                popup.container.style.width = '30%';

                const completionsCopy = [...completions
                    .map((c) => {
                        return {
                            caption: c.caption,
                            value: c.value,
                            meta: c.meta
                        };
                    })];
                this.addSnippets(editor, prefix);
                callback(null, completionsCopy);
            },
            // identifierRegexps: [/[a-zA-Z_0-9\$]/]
        };

        const langTools = ace.acequire('ace/ext/language_tools');
        langTools.setCompleters([this.completer, langTools.snippetCompleter]);

        this.editor.getEditor().setOptions(
            {
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true,
                wrap: true,
                indentedSoftWrap: false
            });
        // this.editor.getEditor().commands.on('afterExec', function (e) {
        //     if (e.command.name === 'insertstring' && /^[\w.]$/.test(e.args)) {
        //         e.editor.execCommand('startAutocomplete');
        //     }
        // });

        this.editor.getEditor().commands.addCommand({
            name: 'Auto Format',
            bindKey: 'Ctrl-i',
            exec: (editor: ace.Editor) => {
                const allContent = editor.getValue();
                const formatted = sqlFormatter.format(allContent, {
                    language: 'sql',
                    indent: '\t'
                });
                editor.setValue(formatted);
                this.onTextChanged(formatted);
            }
        });

    }

    splitSQLTerms(sql: string): string[] {
        return sql.split(/(\t)|( )|(\))|(\()|(\n)/);
    }

    aliasizeText(text: string): string {
        // Backslash escapes. Parens captures the delimiter
        const splits = this.splitSQLTerms(text);
        return splits
            .map((s) => {
                const alias = this.customerColumnAliases[s];
                if (alias) {
                    return `"${alias}"`;
                } else {
                    return s;
                }
            })
            .join('');
    }

    onTextChanged(text) {
        const iterationResults = this.iterateStatement(text);
        this.editor.getEditor().getSession().setAnnotations(iterationResults.annotations);
        this.validations = iterationResults.messages;
        if (iterationResults.annotations.length > 0) {
            this.validations.push(`${iterationResults.annotations.length} errors/warnings exist in the editor`);
        }
        const splits = this.splitSQLTerms(text);
        this.hints = splits
            .map((s) => {
                const alias = this.customerColumnAliases[s];
                if (alias) {
                    return `${s}=${alias}`;
                }
            })
            .filter((value) => {
                return value !== undefined;
            });
        this.literalsUsed = iterationResults.literals.filter((v, i) => iterationResults.literals.indexOf(v) === i);
        this.numbersUsed = iterationResults.numbers.filter((v, i) => iterationResults.numbers.indexOf(v) === i);
    }

    iterateStatement(source: string): { messages: string[], annotations: any[], literals: string[], numbers: string[] } {
        const messages: string[] = [];
        const annotations: any[] = [];
        const literals: string[] = [];
        const numbers: string[] = [];
        // Make sure quotes are matched
        if ((source.split(`'`).length - 1) % 2 !== 0) {
            messages.push('Non even number of quotes');
        }
        // Make sure parens are matched
        const openParenCount = source.split('(').length;
        const closeParenCount = source.split(')').length;
        if (openParenCount !== closeParenCount) {
            messages.push(`Unmatched Parentheses: ${openParenCount} '(' vs ${closeParenCount} ')'`);
        }
        const invalidKeywords = ['FROM', 'SELECT', 'JOIN', 'UNION', 'DELETE', 'CREATE', 'DROP',
            'INSERT', 'UPDATE', 'ALTER', 'ADD', 'ROWNUM', 'TOP', 'WHERE', '*', '--'];
        const TokenIterator = ace.acequire('ace/token_iterator').TokenIterator;
        const session = this.editor.getEditor().getSession();
        const ti = new TokenIterator(session, 0, 0);
        // const tokens = [];
        let t = ti.getCurrentToken();
        const selectableColumns = this.columnMeta
            .map((meta) => {
                return meta.columnName;
            });
        while (t) {
            // console.log(`==${JSON.stringify(t)}`);
            // Check for invalid column names or extraneous terms
            if (t.type === 'identifier' && !['THEN', 'ABS', 'IN', 'LIKE'].includes(t.value.toUpperCase()) &&
                !selectableColumns.includes(t.value.toLowerCase())) {
                this.addAnnotation(annotations,
                    `Possible incorrect column/reference: ${t.value}`,
                    ti.getCurrentTokenRow(), ti.getCurrentTokenColumn(), 'error');
            }
            // Disallowed keywords
            if (t.type === 'keyword' && invalidKeywords.includes(t.value.toUpperCase())) {
                this.addAnnotation(annotations,
                    `${t.value} keyword is not allowed`,
                    ti.getCurrentTokenRow(), ti.getCurrentTokenColumn(), 'error');
            }
            if ((t.type === 'text' && t.value === '`') ||
                (t.type === 'string' && t.value.startsWith('`') && t.value.endsWith('`'))) {
                this.addAnnotation(annotations,
                    `Usage of backticks is not allowed`,
                    ti.getCurrentTokenRow(), ti.getCurrentTokenColumn(), 'error');
            }
            if ((t.type === 'text' && t.value === '"') ||
                (t.type === 'string' && t.value.startsWith('"') && t.value.endsWith('"'))) {
                this.addAnnotation(annotations,
                    `Usage of double quotes is not allowed.`,
                    ti.getCurrentTokenRow(), ti.getCurrentTokenColumn(), 'error');
            }
            if (t.type === 'string' && t.value.startsWith(`'`) && t.value.endsWith(`'`)) {
                literals.push(t.value);
            }
            if (t.type === 'constant.numeric') {
                numbers.push(t.value);
            }


            t = ti.stepForward();
        }

        return {
            messages,
            annotations,
            literals,
            numbers
        };
    }

    addAnnotation(annotations: any[], message: string, row: number, column: number, type: string) {
        annotations.push({
            row,
            column,
            text: message,
            type
        });
    }


    // editor.getSession().setAnnotations([{
    //     row: 1,
    //     column: 0,
    //     text: "Strange error",
    //     type: "error" // also warning and information
    //   }]);


}
// [{ "type": "support.function", "value": "coalesce", "index": 3, "start": 9 }]
// [{ "type": "paren.lparen", "value": "(" }]
// [{ "type": "identifier", "value": "days_since_entered" }]
// [{ "type": "text", "value": ", " }]
// [{ "type": "constant.numeric", "value": "0" }]
// [{ "type": "paren.rparen", "value": ")" }]
// [{ "type": "keyword.operator", "value": "<=" }]
// [{ "type": "identifier", "value": "THEN" }]
// [{ "type": "string", "value": "'1W'" }]
// [{ "type": "keyword", "value": "when" }]
